import { render, staticRenderFns } from "./popup-result.mpx?vue&type=template&id=2611c5ba&scoped=true&isComponent&outputPath=components%2Fpopup-result780e2836%2Findex"
import script from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result780e2836%2Findex"
export * from "./popup-result.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fpopup-result780e2836%2Findex"
import style0 from "./popup-result.mpx?vue&type=style&index=0&id=2611c5ba&prod&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m780e2836%22%7D&isComponent&outputPath=components%2Fpopup-result780e2836%2Findex"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611c5ba",
  null
  
)

export default component.exports